/**
 * Consumer portal (xpillar client) base URL for signing links.
 * Set VITE_CLIENT_PORTAL_URL in env (e.g. https://app.xpillar.com).
 * Hero-api should use this when emailing links: `${origin}/signings/session?token=...`
 */
export function getSigningClientOrigin(): string {
    const raw = import.meta.env.VITE_CLIENT_PORTAL_URL
        || import.meta.env.VITE_XPILLAR_APP_URL
        || import.meta.env.VITE_XPILLAR_URL
        || import.meta.env.VITE_WWW_URL
        || '';
    return String(raw).replace(/\/$/, '');
}

export function buildSigningSessionUrl(token: string): string {
    const origin = getSigningClientOrigin();
    if (!origin || !token) return '';
    return `${origin}/signings/session?token=${encodeURIComponent(token)}`;
}

/** Extra fields to send with document submit so the API can build consumer-portal links. */
export function signingPortalPayload(): { signingClientOrigin?: string } {
    const origin = getSigningClientOrigin();
    return origin ? { signingClientOrigin: origin } : {};
}
